import * as Yup from "yup";

const useSublimationClothPrintConfig = () => {
  const validationSchema = Yup.object({  
    print_type_name: Yup.string().required('Cloth print type name is required'),
    imgpath: Yup.mixed().required('Image is required'), 
  });

  const initialValues = {
    id:0,    
    print_type_name: '',
    imgpath: null,
  };

  return { validationSchema, initialValues };
};

export default useSublimationClothPrintConfig;
